export type LowBalanceWarningSettings = {
  enabled: boolean;
  effectiveThresholdUsd: number | null;
};

export function parseLowBalanceWarningSettings(
  data:
    | {
        low_balance_warning_enabled?: boolean;
        low_balance_effective_threshold_usd?: number | string | null;
      }
    | null
    | undefined,
): LowBalanceWarningSettings {
  if (!data) {
    return { enabled: true, effectiveThresholdUsd: null };
  }

  const enabled = data.low_balance_warning_enabled !== false;
  const raw = data.low_balance_effective_threshold_usd;
  const threshold = raw != null ? Number(raw) : NaN;

  return {
    enabled,
    effectiveThresholdUsd: Number.isFinite(threshold) ? threshold : null,
  };
}

export function isLowCreditBalance(
  balance: number | null,
  settings: LowBalanceWarningSettings,
): boolean {
  if (!settings.enabled) return false;
  if (balance == null || !Number.isFinite(balance)) return false;
  if (settings.effectiveThresholdUsd == null || !Number.isFinite(settings.effectiveThresholdUsd)) {
    return false;
  }
  return balance <= settings.effectiveThresholdUsd;
}
